module.exports = __webpack_public_path__ + "static/media/pic2.2211dfb2.png";